/**
 * LogoInjector Component
 *
 * Example of how to import an image and add it to the DOM.
 * This is a demonstration component showing webpack image imports.
 * Replace the logo path with your actual project logo.
 */

// 1. Import the image. Webpack returns the final public URL of the processed image.
// TODO: Replace with your actual logo file
import logoURL from '../../images/logo.svg';

class LogoInjector {
	constructor( selector ) {
		this.container = document.querySelector( selector );
	}

	init() {
		if ( ! this.container ) {
			return;
		}

		// 2. Create an image element and set its 'src'.
		const logoImage = new Image();
		logoImage.src   = logoURL;
		logoImage.alt   = 'Conversion Talks Logo';
		logoImage.classList.add( 'dynamic-logo' );

		// 3. Append it to the container.
		this.container.appendChild( logoImage );
	}
}

export default LogoInjector;
